import InnerHTML from './InnerHTML';

export default InnerHTML;
